import { ExtendedSubscribable } from '@benzinga/subscribable';
import { deepEqual } from '@benzinga/utils';
import { WidgetLink, WidgetLinkEvent } from './entities';

interface WidgetLinkEventNotification {
  type: 'linking:link_event';
  link: WidgetLink;
  event: WidgetLinkEvent;
}
interface LinkUpdatedEvent {
  link: WidgetLink;
  type: 'linking:link_updated';
}

export type LinkFeedEvents = WidgetLinkEventNotification | LinkUpdatedEvent;

interface SubscriptionExtension {
  getLink: LinkFeed['getLink'];
  getLatestEvent: LinkFeed['getLatestEvent'];
  pushEvent: LinkFeed['pushEvent'];
}

export class LinkFeed extends ExtendedSubscribable<LinkFeedEvents, SubscriptionExtension> {
  private link: WidgetLink;
  constructor(link: WidgetLink) {
    super();
    this.link = link;
  }
  public pushEvent(event: WidgetLinkEvent) {
    this.editLink({ events: [...this.link.events.filter(prevEvent => prevEvent.type !== event.type), event] });
  }
  public getLink() {
    return this.link;
  }
  public editLink(group: Partial<WidgetLink>) {
    if (!deepEqual(this.link, group)) {
      group.events?.forEach(event => this.setEvent(event));
      this.link = Object.assign(this.link, group);
      this.dispatch({ link: this.link, type: 'linking:link_updated' });
    }
  }
  public getLatestEvent(type: string) {
    return this.link.events.find(event => event.type === type);
  }
  protected onSubscribe(_id: number, ..._args: readonly unknown[]): SubscriptionExtension {
    return {
      getLatestEvent: this.getLatestEvent,
      getLink: this.getLink,
      pushEvent: this.pushEvent,
    };
  }
  private setEvent(event: WidgetLinkEvent) {
    if (!deepEqual(this.getLatestEvent(event.type), event)) {
      this.link.events = [...this.link.events.filter(event1 => event1.type !== event.type), event];
      this.dispatch({ event, link: this.link, type: 'linking:link_event' });
    }
  }
}
